<template>
    <div style="background-color: #ffffff;padding: 0 25px 20px;">
      <!-- 已经上架的状态文案：The product will be available in the store early 已经下架的状态文案：This product was previously listed to the store. -->
        <div class="info f--c f-b" style="height: 55px">
            <div class="f">
              <div style="margin-right: 80px" class="f">
                  <span style="color: #8B93A3">{{ $t('publishEdit.Platform') }}: </span><span style="font-weight: bold;">{{platformName}}</span>
              </div>
              <div class="f">
                  <span style="color: #8B93A3">{{ $t('publishEdit.Store') }}: </span><span style="font-weight: bold;"> {{detailObj.storeName}}</span>
              </div>
            </div>
            <div class="f-e" >
              <el-alert :title="platformCode === 'TT' ? $t('publishListings.Active') : $t('Publish.Edit.Components.TopInfo.Published')" type="success" style="font-size:14px;width:100px;text-align:center" :closable="false" v-if="listingStatus === '1'"></el-alert>
              <el-alert :title="platformCode === 'TT' ? $t('publishListings.Inactive') : $t('Publish.Edit.Components.TopInfo.Hidden')" type="info" style="font-size:14px;width:100px;text-align:center" :closable="false" v-else-if="listingStatus === '2'"></el-alert>
            </div>
        </div>
        <div class="f">
            <div style="margin-right: 36px">
                <el-image style="width: 140px;height: 140px" :src="imageUrl" @click="dialogVisible = true" class="pointer" ></el-image>
            </div>
            <div style="flex: 1">
                <el-row :gutter="38">
                    <el-col :span="24" style="margin-bottom: 20px">
                        <div style="height: 30px;line-height: 30px" class="requiredLabel">{{ $t('publishEdit.ProductTitle') }}</div>
                        <div>
                            <el-input :placeholder="$t('publishEdit.selectContent')" class="infoInput borderTo2" :class="{redBorder: !detailObj.title}" v-model="detailObj.title" @blur="value=>inputLengthCheck(value, 'title')"></el-input>
                        </div>
                    </el-col>

                    <template v-if="platformCode === 'TT'">
                      <el-col :span="12" style="margin-bottom: 20px">
                        <div class="sync-collection-box" style="height: 24px;line-height: 24px">
                          <span class="requiredLabel">{{ $t('publishEdit.Category') }}</span>
                          <!-- <span class="syncCollection" @click="publishGetSyncCollections" :class="{syncCollectionDisabled: syncCollectionDisabled}"><i class="el-icon-refresh" ></i>{{ $t('Publish.Edit.Components.TopInfo.Update') }}</span> -->
                        </div>
                        <div class="f--c" style="color: #99C41C;">
                          <el-cascader
                            :options="categoriesList"
                            :props="{ expandTrigger: 'hover', value: 'categoryId', label: 'localName', emitPath: false}"
                            clearable
                            @change="categorysChange"
                            v-model="categoryId"
                            :show-all-levels="false"
                            style="width: 100%"
                            class="borderTo2"></el-cascader>
                        </div>
                      </el-col>
                      <el-col v-if="tiktokAttributes.name" :span="12" style="margin-bottom: 20px">
                        <div class="sync-collection-box" style="height: 24px;line-height: 24px">
                            <span class="requiredLabel">{{ tiktokAttributes.name }}</span>
                        </div>
                        <!-- Tiktok品类必填属性暂时仅支持单选 -->
                        <el-select v-model="productAttributes" :placeholder="$t('productDetail.pleaseSelected')" >
                          <el-option
                            v-for="item in tiktokAttributes.values"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-col>
                    </template>

                    <template v-else>
                      <el-col :span="12" style="margin-bottom: 20px" v-if="submitMode === 'add' && platformCode !== 'WC' && +$route.query.updateProcessed !== 2">
                          <div class="sync-collection-box" style="height: 24px;line-height: 24px">
                            <span>{{ $t('publishEdit.Collections') }}</span>
                            <span class="syncCollection" @click="publishGetSyncCollections" :class="{syncCollectionDisabled: syncCollectionDisabled}"><i class="el-icon-refresh" ></i>{{ $t('Publish.Edit.Components.TopInfo.Update') }}</span>
                          </div>
                          <div v-if="platformCode === 'SP'" class="f--c" style="color: #99C41C;">
                            <el-select
                              multiple
                              :placeholder="$t('publishEdit.selectContent')"
                              style="width: 100%"
                              v-model="detailObj.collectionId"
                              clearable
                              class="borderTo2">
                                <el-option v-for="item in collectionSelectList" :key="item.collectionId" :value="item.collectionId" :label="item.title"></el-option>
                            </el-select>
                          </div>
                          <div v-else class="f--c" style="color: #99C41C;">
                            <el-select
                              :placeholder="$t('publishEdit.selectContent')"
                              style="width: 100%"
                              v-model="detailObj.collectionId"
                              clearable
                              class="borderTo2">
                                <el-option v-for="item in collectionSelectList" :key="item.collectionId" :value="item.collectionId" :label="item.title"></el-option>
                            </el-select>
                          </div>
                      </el-col>

                      <el-col :span="12" style="margin-bottom: 20px" v-if="platformCode === 'WC'">
                          <div class="sync-collection-box" style="height: 24px;line-height: 24px">
                            <span>{{ $t('Publish.Edit.Components.TopInfo.Categorys') }}</span>
                            <span class="syncCollection" @click="publishGetSyncCollections" :class="{syncCollectionDisabled: syncCollectionDisabled}"><i class="el-icon-refresh" ></i>{{ $t('Publish.Edit.Components.TopInfo.Update') }}</span>
                          </div>
                          <div class="f--c" style="color: #99C41C;">
                            <el-cascader
                              :options="collectionSelectList"
                              :props="{ expandTrigger: 'hover', multiple: true, value: 'categoryId', label: 'name', checkStrictly: true }"
                              clearable
                              @change="categorysChange"
                              v-model="categoryIds"
                              :show-all-levels="false"
                              style="width: 100%"
                              class="borderTo2"></el-cascader>
                          </div>
                      </el-col>

                      <el-col :span="12" v-if="!['DJ', 'SL', 'WC'].includes(platformCode)">
                          <div style="height: 24px;line-height: 24px">{{ $t('Publish.Edit.Components.TopInfo.PoductsType') }}</div>
                          <div>
                              <el-input class="infoInput borderTo2" v-model="detailObj.productType" @blur="value=>inputLengthCheck(value, 'productType')"></el-input>
                          </div>
                      </el-col>

                      <el-col :span="24" style="margin-bottom: 20px" v-if="platformCode !== 'WC'">
                          <div style="height: 24px;line-height: 24px">{{ $t('publishEdit.Tags') }}</div>
                          <div style="position: relative;width: 100%;" class="fw-w f" >
                            <el-tag
                              :key="tag"
                              v-for="tag in dynamicTags"
                              closable
                              :disable-transitions="false"
                              @close="handleClose(tag)">
                              {{tag}}
                            </el-tag>
                            <el-input
                              class="input-new-tag borderTo2"
                              v-if="inputVisible"
                              v-model="inputValue"
                              ref="saveTagInput"
                              size="small"
                              @keyup.enter.native="handleInputConfirm"
                              @blur="handleInputConfirm"
                            >
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ {{ $t('Publish.Edit.Components.TopInfo.NewTag') }}</el-button>
                          </div>
                      </el-col>
                      <el-col :span="12" style="margin-bottom:20px" v-else>
                        <div class="sync-collection-box" style="height: 24px;line-height: 24px">
                          {{ $t('publishEdit.Tags') }}
                          <span class="syncCollection" @click="woocommerceSyncTag" :class="{syncCollectionDisabled: tagDisabled}"><i class="el-icon-refresh" ></i>{{ $t('Publish.Edit.Components.TopInfo.Update') }}</span>
                        </div>
                        <div style="position: relative;width: 100%;" class="fw-w f--c">
                            <el-select
                              v-model="tagsValue"
                              multiple
                              filterable
                              allow-create
                              default-first-option
                              style="width: 100%"
                              :placeholder="$t('Publish.Edit.Components.TopInfo.SelectTags')"
                              class="borderTo2">
                              <el-option
                                v-for="item in tagsList"
                                :key="item.name"
                                :label="item.name"
                                :value="item.name">
                              </el-option>
                            </el-select>
                          </div>
                      </el-col>
                    </template>
                </el-row>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="800px">
          <img :src="imageUrl" width="100%" />
      </el-dialog>
    </div>
</template>

<script>

import API from '@/api'

export default {
  props: {
    detailObj: {
      type: Object,
      default: () => ({
        'productId': undefined,
        'kkProductId': undefined,
        'title': undefined,
        'bodyHtml': undefined,
        'listingStatus': undefined,
        'tags': undefined,
        'storeName': undefined,
        'variants': [],
        'options': [],
        'images': [],
        'id': undefined,
        'storeId': undefined,
        'listingId': undefined,
        'collectionId': undefined,
        'collectionName': undefined,
        'imageUrl': undefined,
        productType: undefined
      })
    },
    imageUrl: {
      type: String,
      default: () => ''
    },
    submitMode: {
      type: String,
      default: () => 'add'
    },
    platformCode: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      collectionSelectList: [],
      syncCollectionDisabled: false,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      storeId: '',
      listingStatus: 1,
      dialogVisible: false,
      categoryIds: [],
      tagsValue: [],
      tagsList: [],
      tagDisabled: false,
      categoriesList: [], // TikTok Categories列表
      tiktokAttributes: {}, // Tiktok Attributes列表
      categoryId: undefined, // TikTok 品类id
      productAttributes: ''
    }
  },
  computed: {
    platformName() {
      let name = ''
      let target = this.$store.state.common.platformOptions.find(e => e.platformCode === this.platformCode) || { platformName: '' }
      name = target.platformName || this.$route.query.platformName
      return name
    }
  },
  created() {
    this.$nextTick(() => {
      const { storeId, listingStatus } = this.$route.query
      this.storeId = storeId
      this.listingStatus = listingStatus
      this.handleTag(this.detailObj.tags)
      this.submitMode === 'add' && this.publishGetCollections(storeId)
      if (this.platformCode === 'WC') this.woocommerceGetTag()
      if (this.platformCode === 'TT') {
        this.tiktokGetCategoriesList()
      }
    })
  },
  methods: {
    // 输入框长度校验
    inputLengthCheck(value, key) {
      if (value.target.value.length > 255) {
        this.$message.error(this.$t('promptText.msg44'))
        this.detailObj[key] = this.detailObj[key].slice(0, 255)
      }
    },
    // tags相关
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 同步集合
    async publishGetSyncCollections() {
      const { storeId } = this.detailObj
      try {
        if (!this.syncCollectionDisabled) {
          this.syncCollectionDisabled = true
          let res
          if (this.platformCode === 'DJ') {
            res = await API.shoplazzaSyncCollections({ storeId })
          } else if (this.platformCode === 'SP') {
            res = await API.publishGetSyncCollections({ storeId })
          } else if (this.platformCode === 'SL') {
            res = await API.shoplineSyncCollections({ storeId })
          } else if (this.platformCode === 'WC') {
            res = await API.WoocommerceSyncCollections({ storeId })
          }
          this.publishGetCollections(storeId)
          this.$message.success(res.message)
        }
      } catch (err) {
        let message = err.message || err.data.message
        this.$message.error(message)
      }
      this.syncCollectionDisabled = false
    },
    // 获取集合列表
    async publishGetCollections(storeId, categoryId) {
      // console.log(this.platformCode)
      try {
        let res
        if (this.platformCode === 'DJ') {
          res = await API.shoplazzaGetCollections({ storeId })
        } else if (this.platformCode === 'SP') {
          res = await API.publishGetCollections({ storeId })
        } else if (this.platformCode === 'SL') {
          res = await API.shoplineGetCollections({ storeId })
        } else if (this.platformCode === 'WC') {
          res = await API.WoocommerceGetCategories({ storeId, categoryId })
        }
        const arr = []; const obj = {}
        // 去重 且WC平台为品类数组 字段调整
        if (this.platformCode === 'WC') {
          res.data.list.forEach(e => {
            if (!obj[e.categoryId]) {
              e.collectionId = e.categoryId
              e.title = e.name
              arr.push(e)
            }
            obj[e.categoryId] = 1
          })
        } else {
          res.data.list.forEach(e => {
            if (!obj[e.collectionId]) arr.push(e)
            obj[e.collectionId] = 1
          })
        }
        this.collectionSelectList = arr
        const clearEmptyChildren = (arr) => {
          arr.forEach(e => {
            if (e.children && e.children.length) {
              clearEmptyChildren(e.children)
            } else {
              e.children = null
            }
          })
        }
        clearEmptyChildren(this.collectionSelectList)
        if (this.platformCode === 'WC' && this.detailObj.categoryIdsStr) {
          const basecCategoryIds = this.detailObj.categoryIdsStr.split(',').map(e => Number(e.trim()))
          const finalcategoryIds = []
          // 组件value格式为层级关系，若不为第一级的id需找出层级
          const findFather = (arr, parents, categoryId) => {
            arr.forEach(e => {
              if (e.categoryId !== categoryId && e.children) {
                findFather(e.children, [...parents, e.categoryId], categoryId)
              }
              if (e.categoryId === categoryId) {
                finalcategoryIds.push([...parents, categoryId])
              }
            })
          }
          basecCategoryIds.forEach(categoryId => {
            findFather(this.collectionSelectList, [], categoryId)
          })
          this.categoryIds = finalcategoryIds
          // console.log(this.categoryIds)
        }
      } catch (error) {
        // console.log(error)
      }
    },
    // tags事件
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        if (this.dynamicTags.includes(inputValue)) {
          this.$message.warning(this.$t('publishEdit.repeat'))
        } else if (inputValue.length > 255) {
          this.$message.warning('The number of characters in tags cannot exceed 255!')
          inputValue = inputValue.slice(0, 255)
          this.dynamicTags.push(inputValue)
        } else if (this.dynamicTags.length >= 100) {
          this.$message.warning(this.$t('publishEdit.tagLength'))
        } else {
          this.dynamicTags.push(inputValue)
        }

        // if (!this.dynamicTags.includes(inputValue)) {
        //   this.dynamicTags.push(inputValue)
        // } else if (this.dynamicTags.length >= 10) {
        //   this.$message.warning(this.$t('publishEdit.tagLength'))
        // } else {
        //   this.$message.warning(this.$t('publishEdit.repeat'))
        // }
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    getTags() {
      return this.dynamicTags.join(',')
    },
    handleTag(tags) {
      if (!tags) return
      if (this.platformCode === 'WC') {
        this.tagsValue = tags.map(e => e.name)
      } else {
        this.dynamicTags = tags.split(',')
      }
    },
    woocommerceSyncTag() {
      if (this.tagDisabled) return
      const { storeId } = this.$route.query
      this.tagDisabled = true
      API.woocommerceSyncTag({ storeId }).then(res => {
        this.$message.success(res.message)
        this.woocommerceGetTag()
      }).finally(() => {
        this.tagDisabled = false
      })
    },
    woocommerceGetTag() {
      const { storeId } = this.$route.query
      API.woocommerceGetTag({ storeId }).then(res => {
        this.tagsList = res.data.list
      })
    },
    categorysChange() {
      // console.log(value)
      this.tiktokGetAttributes('change')
    },
    // TT 获取Categories列表
    tiktokGetCategoriesList() {
      const { storeId } = this.$route.query
      API.tiktokGetCategoriesList({ storeId }).then(res => {
        const formatList = (list) => {
          list.forEach(e => {
            if (e.children && e.children.length) {
              formatList(e.children)
            } else {
              e.children = null
            }
          })
        }
        formatList(res.data.list)
        this.categoriesList = res.data.list
      })
    },
    // TT 获取品类必填属性列表
    tiktokGetAttributes(type) {
      const { storeId } = this.$route.query // 从路由参数中获取 storeId 和 categoryId
      API.tiktokGetAttributes({ storeId, categoryId: this.categoryId }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.tiktokAttributes = (res.data.list.length && res.data.list[0]) || []
        this.productAttributes = ''

        if (this.detailObj.productAttributes && this.detailObj.productAttributes.length && type !== 'change') {
          this.productAttributes = this.detailObj.productAttributes[0].values[0].id
        }
        // console.log('--', this.detailObj)
      })
    },
    defaultAttributes() {
      this.tiktokGetAttributes()
    },
    // 根据产品ID获取categoryId
    tiktokGetCategoryId() {
      const { storeId } = this.$route.query
      API.tiktokGetCategoryId({ storeId, kkProductId: this.detailObj.kkProductId }).then(res => {
        this.categoryId = res.data
        this.tiktokGetAttributes()
      })
    }
    // getParentsById(list, id) {
    //   for (let i in list) {
    //     if (list[i][this.propsCascader.value || 'value'] == id) {
    //       return [list[i][this.propsCascader.value || 'value']]
    //     }
    //     if (list[i].children) {
    //       let node = this.getParentsById(list[i].children, id)
    //       if (node !== undefined) {
    //         // 追加父节点
    //         node.unshift(list[i][this.propsCascader.value || 'value'])
    //         return node
    //       }
    //     }
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped>
.syncCollectionDisabled {
  cursor: not-allowed !important;
  color: rgb(139, 147, 163) !important;
}
.requiredLabel::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.infoInput {
  /deep/.el-input__inner {
      border-radius: 30px;
  }
}
.input-new-tag {
  width: 90px;
  margin-right: 10px;
  vertical-align: bottom;
}
.button-new-tag {
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.sync-collection-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .syncCollection {
      color: #99C41C;
      cursor: pointer;
      .el-icon-refresh {
          font-size: 16px;
          margin: 0 5px;
      }
  }
}

.el-tag  {
    margin-right: 10px;
    margin-bottom: 4px;
}
/deep/.borderTo2{
  .el-input__inner{
    border-radius: 2px !important;
  }
}
</style>
